import React, { useState, useContext, useEffect } from 'react'
import Tooltip from '../../../CustomTooltip'
import { Box, Text } from '../../../designSystem'
import { handleEventLog, numFormatter } from '../../../lib/utils'
import Calendar from './BonusCalendar'
import { months } from '../constants'
import {
  BonusStatsText,
  BonusUpperDiv,
  DailyBonusStats,
  InfoIcon,
  SubHeading,
  UpperStatsWrapper,
  MoreIncomeText,
  SecondStatsWrapper,
  DailyBonusStatsText,
  DailyChapterBonusStats,
  LegendWrapper,
  ColorWrapper,
  LegendOuterWrapper,
  DailyBonusLegendWrapper,
  DailyBonusCalendarWrapper,
  CalendarOuterWrapper,
  DailyUpdateBonusWrapper,
} from './styles'
import { Stats } from '../Cards/monthlyBookCard'
import PerformanceCard from '../Cards/performanceCard'
import SeriesPerformanceCard from '../Cards/seriesPerformanceCard'
import { Popup } from '../../../components/Popup'
import LearnMorePopup from './LearnMorePopup'
import DailyChapterBonusCalendar from './DailyChapterBonusCalendar'
import { AccountContext } from '../../../providers/accountProvider'
import { handleNewEventLog } from '../../../lib/utils/events'

const DAILY_CHAPTER_BONUS_LEGEND_MAPPING = [
  {
    color: '#00CB76',
    label: '3 Chps',
  },
  {
    color: '#78FFD8',
    label: '2 Chps',
  },
  {
    color: '#E0FFF6',
    label: '1 Chps',
  },
  {
    color: '#FF4242',
    label: 'Missed',
  },
]

function DailyBonusCard({ bookDetails, dailyBonusData }) {
  const [openLearnMorePopup, setOpenLearnMorePopup] = useState(false)
 
  const date = new Date()
  const { user } = useContext(AccountContext)
  const isUSUser =
    bookDetails?.is_novel === 2 ||
    bookDetails?.program_type === 'writer_benefit_v3_us'
  const todaysDate = `${('0' + date.getDate()).slice(-2)} ${months[
    date.getMonth()
  ].substr(0, 3)} ${date.getFullYear()}`.toString()

  useEffect(() => {
    handleNewEventLog('home','writer_home_daily_update_bonus_viewed',{route : window.location.pathname + window.location.search,module_name: 'home_update_bonus_section'}, user, bookDetails)
  },[])

  const handleLearnMore = () => {
    handleEventLog('home', 'button_click', {
      module_name: 'daily_update_bonus_Learn_more',
      entity_id: bookDetails.book_id,
      entity_type: 'book',
    })
    setOpenLearnMorePopup(true)
  }

  
  return (
    <>
      {openLearnMorePopup && (
        <Popup
          show
          close={() => setOpenLearnMorePopup(false)}
          className={''}
          closeMarksStyles={{ top: '20%' }}
        >
          <LearnMorePopup
            setOpenLearnMorePopup={setOpenLearnMorePopup}
            authorName={bookDetails?.author_name}
            bookId={bookDetails.book_id}
          />
        </Popup>
      )}
      <BonusUpperDiv
        isDailyChapterBonusVisible={
          dailyBonusData?.current_day_chapter_bonus?.toString().length
        }
      >
        <UpperStatsWrapper>
          <DailyUpdateBonusWrapper>
            <Box>
              <Text variant="titleMedium">
                <span style={{ 'margin-right': '2px' }}>
                  {' '}
                  Daily Update Bonus{' '}
                </span>
                <Tooltip
                  content={
                    dailyBonusData?.current_day_chapter_bonus
                      ? 'Daily Update bonus is generated at end of publishing day for max of 3 chapter & upto 2500 words per chapter.'
                      : bookDetails?.words_cap === 'unlimited'
                      ? 'Publish at least 1 chapter & as many chapter to maximum this reward'
                      : `Publish at least 1 chapter & up to ${
                          bookDetails?.daily_bonus_word_count_cap_variant ===
                          'B'
                            ? bookDetails?.words_cap || '5000'
                            : isUSUser
                            ? '2000'
                            : '2500'
                        } words daily to achieve this reward`
                  }
                  direction="bottom"
                >
                  <InfoIcon />
                </Tooltip>
              </Text>
            </Box>
            {!dailyBonusData?.current_day_chapter_bonus &&
              dailyBonusData?.current_day_chapter_bonus?.toString() !== '0' && (
                <SubHeading>
                  <span>
                    Now, publish and earn for upto {isUSUser ? '2000' : '2500'}{' '}
                    words daily!
                  </span>
                </SubHeading>
              )}
            {!!dailyBonusData.current_day_chapter_bonus?.toString().length && (
              <SubHeading>
                <span>PUBLISH & EARN FOR 3 CHAPTERS DAILY !</span>
              </SubHeading>
            )}
            {dailyBonusData?.higher_incentive_variant === 'B' && (
              <SubHeading>
                <span>
                  प्रति माह 18,000 रुपये तक कमाने के लिए बिना रुके हर दिन
                  Publish करें!
                </span>
                {/* Congrats! upgraded to{' '} <span> 20 paise/ word </span> */}
                <button onClick={handleLearnMore}>Learn More {'>>'}</button>
              </SubHeading>
            )}
            <Box mt={16}>
              <Text variant="caption" fontWeight={600}>
                {todaysDate}
              </Text>
            </Box>
            <Box display="flex" gap={2}>
              <Box display="flex" my={4} alignItems="center" mr={8}>
                <DailyBonusStats>
                  {numFormatter(dailyBonusData?.words_published || 0)}
                </DailyBonusStats>
                <BonusStatsText>Words Published</BonusStatsText>
              </Box>
              <Box display="flex" my={4} alignItems="center">
                <DailyBonusStats>
                  {isUSUser && bookDetails?.language === 'english' ? '$' : '₹'}
                  {Number.isInteger(dailyBonusData?.projected_reward || 0)
                    ? dailyBonusData?.projected_reward || 0
                    : (dailyBonusData?.projected_reward || 0).toFixed(2)}
                </DailyBonusStats>
                <BonusStatsText>Projected Reward</BonusStatsText>
              </Box>
            </Box>

            {dailyBonusData && (
              <Box mt={24}>
                <Calendar
                  publishedDates={dailyBonusData?.incentives_data || {}}
                  wbpFirstOngoingDate={dailyBonusData?.wbp_ongoing_date}
                  isUgcBook={isUSUser && bookDetails?.language === 'english'}
                  isDailyBonusVariantB={
                    bookDetails?.daily_bonus_word_count_cap_variant === 'B'
                  }
                />
              </Box>
            )}
          </DailyUpdateBonusWrapper>
          {dailyBonusData?.current_day_chapter_bonus?.toString()?.length >
            0 && (
            <>
              <SecondStatsWrapper>
                <DailyBonusCalendarWrapper backgroundColor="#e9f4fb">
                  <CalendarOuterWrapper>
                    <Box>
                      <Text variant="titleMedium">
                        <span style={{ 'margin-right': '2px' }}>
                          Chapter Bonus
                        </span>
                        <Tooltip
                          content="Generated based on the number of chapters in a given day."
                          direction="bottom"
                        >
                          <InfoIcon />
                        </Tooltip>
                      </Text>
                    </Box>
                    <MoreIncomeText>
                      <span>More Chapter, More Income!</span>
                    </MoreIncomeText>
                    <Box mt={16}>
                      <Text variant="caption" fontWeight={600}>
                        {todaysDate}
                      </Text>
                    </Box>
                    <Box display="flex" gap={2}>
                      <Box display="flex" my={8} alignItems="center" mr={8}>
                        <DailyChapterBonusStats>
                          {dailyBonusData?.current_day_chapter_count > 3
                            ? '3'
                            : dailyBonusData?.current_day_chapter_count}
                          <span className="highlighted-text"> / 3</span>
                        </DailyChapterBonusStats>
                        <DailyBonusStatsText>Chapters</DailyBonusStatsText>
                      </Box>
                      <Box display="flex" my={4} alignItems="center">
                        <DailyBonusStats>
                          ₹
                          {Number.isInteger(
                            dailyBonusData?.current_day_chapter_bonus || 0
                          )
                            ? dailyBonusData?.current_day_chapter_bonus || 0
                            : (
                                dailyBonusData?.current_day_chapter_bonus || 0
                              ).toFixed(2)}
                        </DailyBonusStats>
                        <DailyBonusStatsText>Rewards</DailyBonusStatsText>
                      </Box>
                    </Box>
                    <Box mt={16}>
                      <DailyChapterBonusCalendar
                        publishedDates={dailyBonusData?.incentives_data || {}}
                        wbpFirstOngoingDate={dailyBonusData?.wbp_ongoing_date}
                      />
                    </Box>
                  </CalendarOuterWrapper>
                  <DailyBonusLegendWrapper>
                    <LegendOuterWrapper>
                      {DAILY_CHAPTER_BONUS_LEGEND_MAPPING.map((each) => (
                        <LegendWrapper key={each.label}>
                          <ColorWrapper backgroundColor={each.color} />
                          <p>{each.label}</p>
                        </LegendWrapper>
                      ))}
                    </LegendOuterWrapper>
                  </DailyBonusLegendWrapper>
                </DailyBonusCalendarWrapper>
              </SecondStatsWrapper>
            </>
          )}
        </UpperStatsWrapper>
        <Box>
          <Box backgroundColor="#fdfdfd" mb={8} p={[16, '24px 16px']}>
            <Stats
              views={bookDetails.stats && bookDetails.stats.total_views}
              chapters={bookDetails.chapters_count}
              words={bookDetails.word_count}
              likes={bookDetails?.stats?.likes}
              comments={bookDetails?.stats?.comments}
              newVersion
            />
          </Box>
          <Box backgroundColor="#fdfdfd" p={[16, '24px']}>
            {bookDetails?.is_novel === 2 ? (
              <SeriesPerformanceCard
                bookId={bookDetails.book_id}
                newVersion
                user={user}
                bookDetails={bookDetails}
              />
            ) : (
              <PerformanceCard
                bookId={bookDetails.book_id}
                newVersion
                user={user}
                bookDetails={bookDetails}
              />
            )}
          </Box>
        </Box>
      </BonusUpperDiv>
    </>
  )
}

export default DailyBonusCard
